/**
 * Vista: Lista de Compras Finales
 *
 * Muestra todas las compras registradas con:
 * - Desglose de costos
 * - Análisis de variaciones vs OC
 * - Filtros avanzados
 * - Paginación
 */

import router from '../router/router.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">📦 Compras Finales</h2>
          <button class="btn btn-primary" onclick="router.navigate('/compras/nueva')">
            ➕ Nueva Compra
          </button>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Folio, Factura o Pedimento"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Fecha Desde</label>
            <input
              type="date"
              id="fechaInicio"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Fecha Hasta</label>
            <input
              type="date"
              id="fechaFin"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Proveedor</label>
            <select id="proveedorFilter" class="form-select">
              <option value="">Todos</option>
            </select>
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.comprasListView.limpiarFiltros()" style="width: 100%;">
              🔄 Limpiar
            </button>
          </div>
        </div>

        <!-- Estadísticas -->
        <div id="estadisticas" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <!-- Cargado dinámicamente -->
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Folio</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Proveedor</th>
                <th class="tbl-hide-mobile">OC</th>
                <th class="tbl-hide-mobile">Tractores</th>
                <th class="tbl-hide-mobile">Total Compra</th>
                <th class="tbl-hide-mobile">Total OC</th>
                <th class="tbl-hide-mobile">Variación</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="comprasTableBody">
              <tr>
                <td colspan="10" style="text-align: center; padding: 2rem;">
                  Cargando compras...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination"></div>
      </div>
    `;
  },

  async afterRender() {
    window.comprasListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners para filtros
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.busqueda = e.target.value;
        this.currentPage = 1;
        this.cargarCompras();
      }, 500);
    });

    document.getElementById('fechaInicio').addEventListener('change', (e) => {
      this.filters.fecha_inicio = e.target.value;
      this.currentPage = 1;
      this.cargarCompras();
    });

    document.getElementById('fechaFin').addEventListener('change', (e) => {
      this.filters.fecha_fin = e.target.value;
      this.currentPage = 1;
      this.cargarCompras();
    });

    document.getElementById('proveedorFilter').addEventListener('change', (e) => {
      this.filters.proveedor_id = e.target.value;
      this.currentPage = 1;
      this.cargarCompras();
    });

    // Cargar datos iniciales
    // await this.cargarProveedores(); // Comentado temporalmente
    // await this.cargarEstadisticas(); // Comentado temporalmente
    await this.cargarCompras();
  },

  async cargarProveedores() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/personas/rol/proveedor`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar proveedores');

      const result = await response.json();
      const select = document.getElementById('proveedorFilter');

      result.data.personas.forEach(proveedor => {
        const option = document.createElement('option');
        option.value = proveedor.id;
        option.textContent = proveedor.nombre_comercial || proveedor.nombre_completo;
        select.appendChild(option);
      });
    } catch (error) {
      console.error('Error al cargar proveedores:', error);
    }
  },

  async cargarEstadisticas() {
    try {
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams();

      if (this.filters.fecha_inicio) params.append('fecha_inicio', this.filters.fecha_inicio);
      if (this.filters.fecha_fin) params.append('fecha_fin', this.filters.fecha_fin);

      const response = await fetch(`${window.API_BASE_URL}/compras/estadisticas?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar estadísticas');

      const result = await response.json();
      const stats = result.data;

      document.getElementById('estadisticas').innerHTML = `
        <div class="stat-card">
          <div class="stat-label">Total Compras</div>
          <div class="stat-value">${stats.total_compras || 0}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Monto Total</div>
          <div class="stat-value">$${this.formatNumber(stats.monto_total || 0)} USD</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Promedio Compra</div>
          <div class="stat-value">$${this.formatNumber(stats.promedio_compra || 0)} USD</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Tractores Comprados</div>
          <div class="stat-value">${stats.total_tractores || 0}</div>
        </div>
      `;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarCompras() {
    try {
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams({
        pagina: this.currentPage,
        limite: this.limit
      });

      // Agregar filtros
      if (this.filters.busqueda) {
        params.append('folio', this.filters.busqueda);
        params.append('numero_factura', this.filters.busqueda);
        params.append('pedimento', this.filters.busqueda);
      }
      if (this.filters.fecha_inicio) params.append('fecha_inicio', this.filters.fecha_inicio);
      if (this.filters.fecha_fin) params.append('fecha_fin', this.filters.fecha_fin);
      if (this.filters.proveedor_id) params.append('proveedor_id', this.filters.proveedor_id);

      const response = await fetch(`${window.API_BASE_URL}/compras?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar compras');

      const result = await response.json();
      this.renderTabla(result.data.compras);
      this.renderPaginacion(result.data.paginacion);
    } catch (error) {
      console.error('Error al cargar compras:', error);
      this.mostrarError('Error al cargar las compras');
    }
  },

  renderTabla(compras) {
    const tbody = document.getElementById('comprasTableBody');

    if (compras.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="10" style="text-align: center; padding: 2rem;">
            No se encontraron compras
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = compras.map(compra => {
      const variacionHtml = this.renderVariacion(compra.variacion_monto, compra.variacion_porcentaje);
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.comprasListView.toggleRow(${compra.id})">&#9654;</button></td>
        <td><strong>${compra.folio}</strong></td>
        <td class="tbl-hide-mobile">${this.formatDate(compra.fecha_compra)}</td>
        <td class="tbl-hide-mobile">${compra.proveedor_nombre || 'N/A'}</td>
        <td class="tbl-hide-mobile">
          <span class="badge badge-info">${compra.orden_compra_folio || 'N/A'}</span>
        </td>
        <td class="tbl-hide-mobile" style="text-align: center;">
          <span class="badge badge-primary">${compra.total_tractores || 0}</span>
        </td>
        <td class="tbl-hide-mobile">
          <strong>$${this.formatNumber(compra.total)} ${compra.moneda}</strong>
          <div style="font-size: 0.85rem; color: #666;">
            Base: $${this.formatNumber(compra.costo_base)}
          </div>
        </td>
        <td class="tbl-hide-mobile">$${this.formatNumber(compra.orden_compra_total || 0)} ${compra.moneda}</td>
        <td class="tbl-hide-mobile">${variacionHtml}</td>
        <td class="tbl-hide-mobile">
          <div class="action-buttons">
            <button class="btn btn-sm btn-secondary" onclick="router.navigate('/compras/${compra.id}')" title="Ver Detalle">👁️</button>
            <button class="btn btn-sm btn-info" onclick="window.comprasListView.verAnalisis(${compra.id})" title="Ver Análisis">📊</button>
          </div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-compra-${compra.id}">
        <td colspan="10" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${this.formatDate(compra.fecha_compra)}</dd>
            <dt>Proveedor</dt><dd>${compra.proveedor_nombre || 'N/A'}</dd>
            <dt>OC</dt><dd>${compra.orden_compra_folio || 'N/A'}</dd>
            <dt>Tractores</dt><dd>${compra.total_tractores || 0}</dd>
            <dt>Total Compra</dt><dd>$${this.formatNumber(compra.total)} ${compra.moneda}</dd>
            <dt>Total OC</dt><dd>$${this.formatNumber(compra.orden_compra_total || 0)} ${compra.moneda}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            <button class="btn btn-sm btn-secondary" onclick="router.navigate('/compras/${compra.id}')">👁️ Ver</button>
            <button class="btn btn-sm btn-info" onclick="window.comprasListView.verAnalisis(${compra.id})">📊 Análisis</button>
          </div>
        </td>
      </tr>
    `}).join('');
  },

  renderVariacion(monto, porcentaje) {
    if (!monto || monto === 0) {
      return '<span class="badge badge-secondary">Sin variación</span>';
    }

    const tipo = monto > 0 ? 'sobrecosto' : 'ahorro';
    const color = monto > 0 ? '#dc3545' : '#28a745';
    const signo = monto > 0 ? '+' : '';

    return `
      <div style="text-align: center;">
        <div style="color: ${color}; font-weight: bold;">
          ${signo}$${this.formatNumber(Math.abs(monto))}
        </div>
        <div style="font-size: 0.85rem; color: ${color};">
          ${signo}${porcentaje}%
        </div>
      </div>
    `;
  },

  renderPaginacion(paginacion) {
    const paginacionDiv = document.getElementById('pagination');

    if (paginacion.total_paginas <= 1) {
      paginacionDiv.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    // Botón anterior
    if (paginacion.pagina_actual > 1) {
      html += `<button class="btn btn-sm btn-secondary" onclick="window.comprasListView.cambiarPagina(${paginacion.pagina_actual - 1})">❮ Anterior</button>`;
    }

    // Números de página
    for (let i = 1; i <= paginacion.total_paginas; i++) {
      if (
        i === 1 ||
        i === paginacion.total_paginas ||
        (i >= paginacion.pagina_actual - 2 && i <= paginacion.pagina_actual + 2)
      ) {
        const active = i === paginacion.pagina_actual ? 'btn-primary' : 'btn-secondary';
        html += `<button class="btn btn-sm ${active}" onclick="window.comprasListView.cambiarPagina(${i})">${i}</button>`;
      } else if (i === paginacion.pagina_actual - 3 || i === paginacion.pagina_actual + 3) {
        html += '<span style="padding: 0 0.5rem;">...</span>';
      }
    }

    // Botón siguiente
    if (paginacion.pagina_actual < paginacion.total_paginas) {
      html += `<button class="btn btn-sm btn-secondary" onclick="window.comprasListView.cambiarPagina(${paginacion.pagina_actual + 1})">Siguiente ❯</button>`;
    }

    html += '</div>';
    paginacionDiv.innerHTML = html;
  },

  cambiarPagina(pagina) {
    this.currentPage = pagina;
    this.cargarCompras();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },

  limpiarFiltros() {
    this.filters = {};
    this.currentPage = 1;

    document.getElementById('busqueda').value = '';
    document.getElementById('fechaInicio').value = '';
    document.getElementById('fechaFin').value = '';
    document.getElementById('proveedorFilter').value = '';

    this.cargarEstadisticas();
    this.cargarCompras();
  },

  async verAnalisis(compraId) {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/compras/${compraId}/analisis-variaciones`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar análisis');

      const result = await response.json();
      const analisis = result.data;

      this.mostrarModalAnalisis(analisis);
    } catch (error) {
      console.error('Error al cargar análisis:', error);
      this.mostrarError('Error al cargar el análisis');
    }
  },

  mostrarModalAnalisis(analisis) {
    // Remover modal anterior si existe
    const existente = document.getElementById('modalAnalisis');
    if (existente) existente.remove();

    const modal = document.createElement('div');
    modal.className = 'modal';
    modal.id = 'modalAnalisis';
    modal.innerHTML = `
      <div class="modal-content" style="max-width: 600px;">
        <div class="modal-header">
          <h3 class="modal-title">📊 Análisis Detallado de Variaciones</h3>
          <button class="modal-close" onclick="document.getElementById('modalAnalisis').remove()">✕</button>
        </div>
        <div class="modal-body">
          <div style="margin-bottom: 1.5rem;">
            <h4>${analisis.compra_folio}</h4>
            <p style="color: #666;">Comparación con OC ${analisis.orden_compra_folio}</p>
          </div>

          <h5 style="margin-bottom: 0.75rem;">Desglose de Costos</h5>
          <div style="display: grid; gap: 1rem;">
            <div class="stat-card" style="background: #f8f9fa; padding: 1rem; border-radius: 8px;">
              <div style="font-size: 0.9rem; color: #666;">Orden de Compra (Estimado)</div>
              <div style="font-size: 1.5rem; font-weight: bold; color: #007bff;">
                $${this.formatNumber(analisis.orden_compra_total)} USD
              </div>
            </div>

            <div class="stat-card" style="background: #f8f9fa; padding: 1rem; border-radius: 8px;">
              <div style="font-size: 0.9rem; color: #666;">Compra Final (Real)</div>
              <div style="font-size: 1.5rem; font-weight: bold;">
                $${this.formatNumber(analisis.compra_total)} USD
              </div>
              <div style="margin-top: 0.75rem; font-size: 0.85rem; display: grid; grid-template-columns: 1fr 1fr; gap: 0.25rem;">
                <div>Base: <strong>$${this.formatNumber(analisis.costo_base)}</strong></div>
                <div>Accesorios: <strong>$${this.formatNumber(analisis.costo_accesorios)}</strong></div>
                <div>Impuestos: <strong>$${this.formatNumber(analisis.costo_impuestos)}</strong></div>
                <div>Gastos: <strong>$${this.formatNumber(analisis.costo_gastos)}</strong></div>
                <div>Flete: <strong>$${this.formatNumber(analisis.costo_flete)}</strong></div>
              </div>
            </div>

            <div class="stat-card" style="background: ${analisis.tipo_variacion === 'sobrecosto' ? '#fee2e2' : '#d1fae5'}; padding: 1rem; border-radius: 8px;">
              <div style="font-size: 0.9rem; color: #666;">Variación Total</div>
              <div style="font-size: 1.5rem; font-weight: bold; color: ${analisis.tipo_variacion === 'sobrecosto' ? '#dc3545' : '#28a745'};">
                ${analisis.variacion_monto >= 0 ? '+' : ''}$${this.formatNumber(Math.abs(analisis.variacion_monto))} USD
              </div>
              <div style="font-size: 1.2rem; color: ${analisis.tipo_variacion === 'sobrecosto' ? '#dc3545' : '#28a745'};">
                ${analisis.variacion_porcentaje >= 0 ? '+' : ''}${analisis.variacion_porcentaje}%
              </div>
              <div style="margin-top: 0.75rem;">
                <span class="badge" style="background: ${analisis.tipo_variacion === 'sobrecosto' ? '#dc3545' : '#28a745'}; color: white; padding: 0.5rem 1rem;">
                  ${analisis.tipo_variacion === 'sobrecosto' ? '⚠️ Sobrecosto' : '✅ Ahorro'}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" onclick="document.getElementById('modalAnalisis').remove()">
            Cerrar
          </button>
        </div>
      </div>
    `;

    // Cerrar modal al hacer clic fuera
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.remove();
      }
    });

    document.body.appendChild(modal);
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-compra-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  mostrarError(mensaje) {
    const tbody = document.getElementById('comprasTableBody');
    tbody.innerHTML = `
      <tr>
        <td colspan="10" style="text-align: center; padding: 2rem; color: #dc3545;">
          ⚠️ ${mensaje}
        </td>
      </tr>
    `;
  },

  formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  },

  formatNumber(num) {
    if (!num) return '0.00';
    return parseFloat(num).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
};
